// extracted by mini-css-extract-plugin
export default {"copyright":"footer_copyright__a6Rx0","footer":"footer_footer__yxHCF","footerBg":"footer_footerBg__0x65R","footerInner":"footer_footerInner__Poi5O"};